var map = {
	"./backgrounds/bottom.png": "4bc7",
	"./backgrounds/bottom.webp": "d432",
	"./backgrounds/fill.png": "7a7b",
	"./backgrounds/fill.webp": "91f5",
	"./backgrounds/left.png": "d117",
	"./backgrounds/left.webp": "4d42",
	"./backgrounds/right.png": "4a12",
	"./backgrounds/right.webp": "a0ea",
	"./backgrounds/top.png": "dd6c",
	"./backgrounds/top.webp": "d350",
	"./css/fonts/LavishlyYours-Regular.ttf": "39f8",
	"./css/fonts/SEGOEPR.TTF": "5c8c",
	"./css/fonts/SEGOEPRB.TTF": "0c86",
	"./css/global.less": "bd4b",
	"./css/hexagons.css": "d50a",
	"./css/transitions.less": "e918",
	"./css/variables.less": "c619",
	"./flags/en.png": "d615",
	"./flags/ro.png": "09e8",
	"./others/header.png": "4e20",
	"./others/inv_en.png": "2f15",
	"./others/inv_en.webp": "4e6e",
	"./others/inv_ro.png": "3548",
	"./others/inv_ro.webp": "00ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";